import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Redirect away from Firebase URLs before mounting React
if (process.env.REACT_APP_ENVIRONMENT === 'production' && 
 (window.location.hostname.endsWith('.web.app')) || 
    window.location.hostname.endsWith('.firebaseapp.com')) {
  window.location.replace(
    `https://oracy.solutions${window.location.pathname}${window.location.search}${window.location.hash}`
  );
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
    <App />
  </React.StrictMode>
  );
}

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
